var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductDet = function SvgProductDet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 437,
    fill: "none",
    viewBox: "0 0 552 437"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M319.984 140H166.998c-9.216 0-15.007-9.669-10.357-17.413l66.115-110.992C227.068 4.343 234.423.451 241.99 0h3.044c7.567.45 14.922 4.343 19.234 11.595l66.115 110.992c4.608 7.744-1.184 17.413-10.399 17.413"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M401.117 288H85.829c-9.086 0-14.796-9.597-10.211-17.283l37.718-63.726 30.882-52.216c2.126-3.579 6.002-5.775 10.253-5.775h178.128c4.21 0 8.127 2.196 10.253 5.775l30.883 52.216 37.717 63.726c4.46 7.645-1.25 17.283-10.335 17.283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M463.319 437H23.699C5.496 437-5.9 417.661 3.2 402.174l58.45-99.356A11.86 11.86 0 0 1 71.877 297h343.221c4.216 0 8.141 2.212 10.228 5.818l58.449 99.356c9.143 15.487-2.254 34.826-20.457 34.826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0851",
    d: "M249.333 70a5.333 5.333 0 1 0-10.666 0 5.333 5.333 0 1 0 10.666 0M548 69H244v2h304zM249.333 367a5.33 5.33 0 0 0-5.333-5.333 5.333 5.333 0 1 0 5.333 5.333M548 366H244v2h304zM253.333 219a5.33 5.33 0 0 0-5.333-5.333 5.333 5.333 0 1 0 5.333 5.333M552 218H248v2h304z"
  })));
};
export default SvgProductDet;